module.exports = __webpack_public_path__ + "img/characters.b78d1da1.png";